import initVimeoControllerByAttributes from '../common-util/vimeo/init-vimeo-controller-by-attributes'
import { BehaviorSubject } from 'rxjs'

const vimeoContainerClass = 'video-player__video'
const mutedClass = 'video-player--muted'
const pausedClass = 'video-player--paused'
const clickCoverClass = 'video-player__click-cover'
const playButtonClass = 'video-player__play-button'
const unmuteButtonClass = 'video-player__unmute-button'

export default class VideoPlayerController {
  constructor (element, videoPlayerRegistry) {
    this._element = element
    this._videoPlayerRegistry = videoPlayerRegistry
    this._initVimeo()
    this._bindUIActions()
    this._alwaysMuted = this._element.getAttribute('data-video-player-always-muted') !== null
  }

  _initVimeo () {
    const vimeoContainer = this._getVimeoContainer()
    this._vimeoController = initVimeoControllerByAttributes(vimeoContainer)
    vimeoContainer.vimeoController = this._vimeoController

    this._vimeoController.player.then(player => {
      player.setVolume(0)
    })
  }

  _coverClick () {
  }

  _getClickCover () {
    return this._element.querySelector('.' + clickCoverClass)
  }

  _getPlayButton () {
    return this._element.querySelector('.' + playButtonClass)
  }

  _getUnmuteButton () {
    return this._element.querySelector('.' + unmuteButtonClass)
  }

  _getVimeoContainer () {
    return this._element.querySelector('.' + vimeoContainerClass)
  }

  _playWithSound () {
    this._vimeoController.player.then(player => {
      player.play(1)
    })
    if (!this._alwaysMuted) {
      this._unmute()
    }
  }

  _pause () {
    this._vimeoController.player.then(player => {
      player.pause()
    })
  }

  _unmute () {
    if (this._videoPlayerRegistry) {
      this._videoPlayerRegistry.muteAll()
    }

    if (!this._alwaysMuted) {
      this._vimeoController.player.then(player => {
        console.log('unmuting')
        player.setVolume(1)
      })
    }
  }

  mute () {
    return this._vimeoController.player.then(player => {
      return player.setVolume(0)
    })
  }

  _bindUIActions () {
    this._pausedSubject = new BehaviorSubject(true)
    this._vimeoController.player.then(player => {
      player.getPaused().then((paused) => {
        this._pausedSubject.next(paused)
      })
      player.on('play', () => {
        this._pausedSubject.next(false)
      })
      player.on('pause', () => {
        this._pausedSubject.next(true)
      })
    })

    this._mutedSubject = new BehaviorSubject(true)
    this._vimeoController.player.then(player => {
      player.getVolume().then((volume) => {
        console.log('volume', volume)
        this._mutedSubject.next(volume === 0)
      })
      player.on('volumechange', (data) => {
        console.log('volume', data.volume)
        this._mutedSubject.next(data.volume === 0)
      })
    })

    this._pausedSubject.subscribe((paused) => {
      console.log('paused', paused)
      const element = this._element
      console.log('pausedelement', element)
      const toggleClass = pausedClass
      if (paused) {
        console.log('add paused class')
        element.classList.add(toggleClass)
      } else {
        console.log('remove paused class')
        element.classList.remove(toggleClass)
      }
    })

    this._mutedSubject.subscribe((muted) => {
      console.log('muted', muted)
      const toggleClass = mutedClass
      const element = this._element
      if (muted) {
        element.classList.add(toggleClass)
      } else {
        element.classList.remove(toggleClass)
      }
    })

    const playButton = this._getPlayButton()
    if (playButton) {
      playButton.addEventListener('click', () => {
        this._playWithSound()
      })
    }

    const unmuteButton = this._getUnmuteButton()
    if (unmuteButton) {
      unmuteButton.addEventListener('click', () => {
        this._unmute()
      })
    }

    const clickCover = this._getClickCover()
    if (clickCover) {
      clickCover.addEventListener('click', () => {
        const paused = this._pausedSubject.value
        const muted = this._mutedSubject.value
        if (paused || (!this._alwaysMuted && muted)) {
          this._playWithSound()
        } else {
          this._pause()
        }
      })
    }

    // combineLatest(this.pausedSubject, this.mutedSubject).subscribe((paused, muted) => {
    //   if (paused) {
    //     this._getPlayButton().style.display = 'block'
    //     this._getUnmuteButton().style.display = 'none'
    //   } else if (muted) {
    //     this._getPlayButton().style.display = 'none'
    //     this._getUnmuteButton().style.display = 'block'
    //   } else {
    //     this._getPlayButton().style.display = 'none'
    //     this._getUnmuteButton().style.display = 'none'
    //   }
    // })
  }
}
